<template>
  <ConfirmDialog
    :show="show"
    :title="$t('unsavedChanges')"
    :message="$t('unsavedChangesDialog')"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
  />
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  props: {
    show: Boolean,
  },
  components: {
    ConfirmDialog,
  },
}
</script>
